import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const NotFound = () => {
  useEffect(() => {
    document.title = "Page not found — Click World Online";
  }, []);
  return (
    <section className="relative bg-navy-deep min-h-[100svh] flex items-center grain overflow-hidden" data-testid="not-found-page">
      <div className="absolute inset-0 dot-grid opacity-20" aria-hidden="true" />
      <div className="relative max-w-8xl mx-auto px-6 lg:px-12 py-40 w-full">
        <p className="font-display font-black text-outline text-[30vw] lg:text-[18rem] leading-none select-none" aria-hidden="true">
          404
        </p>
        <h1 className="font-display text-3xl md:text-5xl font-extrabold tracking-tighter text-mist -mt-4 lg:-mt-10">
          This page didn't click.
        </h1>
        <p className="mt-4 text-slatec max-w-md leading-relaxed">
          The page you're looking for doesn't exist or has moved. Let's get you back on track.
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/" data-testid="not-found-home" className="inline-flex items-center gap-2 bg-brand hover:bg-electric hover:text-navy-deep text-white font-semibold px-8 py-4 rounded-full transition-colors duration-300">
            Back to Home <ArrowUpRight size={18} />
          </Link>
          <Link to="/contact" data-testid="not-found-contact" className="inline-flex items-center gap-2 border border-white/20 text-mist hover:border-electric hover:text-electric font-semibold px-8 py-4 rounded-full transition-colors duration-300">
            Contact Us
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
